/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { TextArea, asField } from "informed";
import ValidateItem from "../../../helpers/validation/validateInput";
import validatehoc from "../Validator";

class MultilineTextInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: true,
			maxRows: 25,
			minRows: 5,
			rows: 5,
		};
	}

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	handleChange = event => {
		const textareaLineHeight = 20;
		const { minRows, maxRows } = this.state;

		const previousRows = event.target.rows;
		event.target.rows = minRows; // reset number of rows in textarea

		const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

		if (currentRows === previousRows) {
			event.target.rows = currentRows;
		}

		if (currentRows >= maxRows) {
			event.target.rows = maxRows;
			event.target.scrollTop = event.target.scrollHeight;
		}

		this.setState({
			rows: currentRows < maxRows ? currentRows : maxRows,
		});
	};

	render() {
		const { placeholder, fieldState, helperText, isRequired } = this.props;
		const { error } = fieldState;
		const { minimizePlaceholder } = this.state;
		const hasError = error ? " has-error" : "";

		var propsToPass = Object.assign({}, this.props);
		if (propsToPass.placeholder) {
			delete propsToPass.placeholder;
		}
		return (
			<Fragment>
				<div className={`input-wrap focus ${hasError}`}>
					<div className="input-box-wrap">
						<div className="placeholder">
							<span className={minimizePlaceholder ? "caption-text" : ""}>
								{isRequired && <span className="isrequired-label">*</span>}
								{placeholder}
							</span>
						</div>
						<div className="input-box">
							<TextArea
								rows={this.state.rows}
								placeholder={placeholder}
								fieldState={fieldState}
								{...propsToPass}
								onChange={this.handleChange}
								autoComplete={this.props.autocomplete ? this.props.autocomplete : null}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<div className="caption-text helper-message">{helperText}</div>
						</div>
						<div className="col-xs-6">
							<div className="error-message caption-text">{error ? error : ""}</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

MultilineTextInput.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	helperText: PropTypes.string,
	fieldState: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <MultilineTextInput fieldState={fieldState} {...props} />)
);

export default Wrapper;
